import { useTranslation } from 'react-i18next';
import LoadingSpinner from '../components/lib/UI/loadingSpinner/LoadingSpinner';
import { useAppSelector } from 'setup/store';
import ErrorBox from 'components/lib/error-box';
import { useNavigate, useParams } from 'react-router-dom';
import UserDataForm from 'components/user/user-data-form/UserDataForm';
import { Box } from '@mui/material';
import { useEffect } from 'react';
import { UserRolePriority, UserRoleTypeEnum } from 'common/constants/user';

const AddUserPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const loading = useAppSelector((store) => store.userReducer.loading);
  const error = useAppSelector((store) => store.userReducer.error);
  const loggedInUser = useAppSelector((store) => store.appReducer.loggedInUser);
  const roleIdMap = useAppSelector((store) => store.userReducer.roleIdMap);

  useEffect(() => {
    if (loggedInUser && loggedInUser?.roleId && roleIdMap) {
      if (roleIdMap[loggedInUser.roleId].priority <= UserRolePriority[UserRoleTypeEnum.STORE_ADMIN]) {
        navigate('/404');
      }
    }
  }, [loggedInUser, roleIdMap]);
  return (
    <section style={{ marginBottom: '80px' }}>
      <Box display="flex" flexDirection={{ xs: 'column', md: 'row' }} gap={2} className="pageTitleTitleContainer">
        <h2 className="pageTitle">{t('page.addNewUser')}</h2>
      </Box>
      {error ? <ErrorBox title="Error" message={error.msg} /> : null}
      <UserDataForm userId={undefined} addNew />
    </section>
  );
};

export default AddUserPage;
